import { ClientConfigProductName } from '@frontend/vanilla/core';

export const StandingsWidgetLoader = {
    id: 'standing-widget',
    loaderFn: () => import('./standings-widget.feature'),
    product: ClientConfigProductName.SPORTS,
};
